"use strict";
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @packageDocumentation
 * @module metrics
 */
/**
 * Log levels, for RecordType == Log.
 */
/**
 * @ignore
 */
var Level;
(function (Level) {
    Level["ERROR"] = "ERROR";
    Level["WARN"] = "WARN";
    Level["INFO"] = "INFO";
    Level["DEBUG"] = "DEBUG";
    Level["TRACE"] = "TRACE";
})(Level = exports.Level || (exports.Level = {}));
//# sourceMappingURL=Level.js.map